import { Button, FormGroup } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import type { InstrumentType } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { JobType } from '../../../../../entities/transcription';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';
import { INSTRUMENTS } from './Instrument.config';

const useStyles = makeStyles()((theme) => ({
  instrumentSelection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    padding: 10,
    margin: 5,
    '&:hover': {
      boxShadow: `0px 0px 5px 0 ${theme.palette.secondary.main}`,
    },
    '&:disabled': {
      filter: 'grayscale(.8) opacity(0.8)',
    },
  },
  instruments: {
    gap: 1,
    margin: 1,
    marginLeft: 5,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      gap: 2,
    },
  },
  label: {
    height: '3.4em',
    width: '6em',
    color: '#d1cfcf',
    fontSize: '15px',
    textTransform: 'initial',
  },
  selected: {
    boxShadow: `0px 0px 5px 0 ${theme.palette.primary.main}`,
  },
}));

export interface InstrumentsSelectionProps {}

const RockModeForGuitarSummit: React.FC<InstrumentsSelectionProps> = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [instruments, setInstruments] = React.useState<InstrumentType[]>([]);

  const next = useNextStepAfterUpdate();

  const changeInstruments = (instrument: InstrumentType) => {
    if (instruments.includes(instrument)) {
      setInstruments(instruments.filter((instr) => instr !== instrument));
    } else {
      setInstruments([...instruments, instrument]);
    }
  };

  const handleClick = (rockMode: boolean) => {
    next({ instruments, model: rockMode ? 'rock' : undefined, solo: instruments.length > 0 });
  };

  return (
    <>
      <div className={classes.instruments}>
        {INSTRUMENTS?.[JobType.TranscribeStudio]?.config
          .filter(
            (iconConfig) => iconConfig?.type !== 'multiple' && iconConfig?.models?.includes('rock')
          )
          .map((iconConfig) => (
            <div key={iconConfig.type}>
              <Button
                name={iconConfig.type}
                id={`btn_wizard_${iconConfig.type}`}
                className={
                  instruments.includes(iconConfig.type as InstrumentType)
                    ? `${classes.instrumentSelection} ${classes.selected}`
                    : classes.instrumentSelection
                }
                key={iconConfig.type}
                onClick={() => changeInstruments(iconConfig.type as InstrumentType)}>
                <div>{iconConfig.component}</div>
                <div className={classes.label}>{t(iconConfig.label)}</div>
              </Button>
            </div>
          ))}
      </div>
      <FormGroup
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '20px',
          gap: '20px',
        }}>
        <Button
          variant="contained"
          id="btn_wizard_standard_mode"
          onClick={() => handleClick(false)}>
          STANDARD MODE
        </Button>
        <Button variant="contained" id="btn_wizard_rock_mode" onClick={() => handleClick(true)}>
          ROCK MODE
        </Button>
      </FormGroup>
    </>
  );
};

export default RockModeForGuitarSummit;
